import React from "react";
import { NotifTabMenu } from "../styled/dashboard";

const TabMenu = ({ active, tabChange, tabs, className }) => {
  return (
    <NotifTabMenu className={className}>
      {tabs.map((item, idx) => (
        <li className={idx === active ? "active" : "inactive"} onClick={() => tabChange(idx)}>
          {item.label}
          {className === "sub" && <span> &#40;{item.length}&#41;</span>}
        </li>
      ))}
    </NotifTabMenu>
  );
};

export default TabMenu;
